<template>
  <div
    v-if="page"
    class="contact-page"
  >
    <UContainer>
      <div class="contact-card">
        <h1 class="contact-title">
          Neem contact op
        </h1>
        <p class="contact-subtitle">
          Heb je vragen over Sociale Hygiëne of onze trainingen? Vul het formulier in en wij nemen snel contact met je op!
        </p>
        <UForm
          :state="form"
          @submit="submitForm"
        >
          <UFormGroup
            label="Naam"
            required
          >
            <UInput
              v-model="form.name"
              icon="i-heroicons-user"
              placeholder="Naam"
            />
          </UFormGroup>
          <UFormGroup
            label="E-mail"
            required
          >
            <UInput
              v-model="form.email"
              type="email"
              icon="i-heroicons-envelope"
              placeholder="E-mail"
            />
          </UFormGroup>
          <UFormGroup label="Telefoon">
            <UInput
              v-model="form.phone"
              type="tel"
              icon="i-heroicons-phone"
              placeholder="Telefoon"
            />
          </UFormGroup>
          <UFormGroup
            label="Bericht"
            required
          >
            <UTextarea
              v-model="form.message"
              icon="i-heroicons-chat-bubble-left-ellipsis"
              placeholder="Bericht"
              :rows="4"
            />
          </UFormGroup>
          <UButton
            type="submit"
            color="primary"
            block
            class="contact-btn"
          >
            Verstuur bericht
          </UButton>
        </UForm>
      </div>
    </UContainer>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const { data: page } = await useAsyncData('over-ons', () => queryContent('/').findOne())
if (!page.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page not found', fatal: true })
}

useSeoMeta({
  titleTemplate: '',
  title: page.value.title,
  ogTitle: page.value.title,
  description: page.value.description,
  ogDescription: page.value.description
})

const form = ref({
  name: '',
  email: '',
  phone: '',
  message: ''
})

async function submitForm() {
  try {
    console.log('Submitting form:', form.value)
    await $fetch('/api/contactform/sendcontactform', {
      method: 'POST',
      body: { ...form.value }
    })
    alert('Bedankt voor je bericht! We nemen snel contact met je op.')
    form.value = { name: '', email: '', phone: '', message: '' }
  } catch (error) {
    alert('Er is iets misgegaan met het verzenden van het formulier. Probeer het later opnieuw.')
  }
}
</script>

<style scoped>
.contact-page {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
}

.contact-card {
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 6px 32px rgba(60, 60, 120, 0.10);
  padding: 2.5rem 2rem 2rem 2rem;
  margin-top: 2rem;
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.contact-title {
  text-align: center;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #1a237e;
}

.contact-subtitle {
  text-align: center;
  color: #555;
  margin-bottom: 2rem;
  font-size: 1.1rem;
}

.contact-btn {
  font-weight: 600;
  letter-spacing: 1px;
  margin-top: 1rem;
}
</style>
